import { h } from 'preact'
import { Text, Localizer } from 'preact-i18n'

function isLightColor(hexcolor){
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    return yiq >= 220;
}

export default ({color, classes = '', label = "", selected, onClick, material, pattern}) =>
    <Localizer>
        <div 
            class={`limba__panel-color${classes ? (' ' + classes) : ''}${selected ? ' selected' : ''}${isLightColor(color.substr(1)) ? ' dark-dot bordered' : ''}${material ? ' material-' + material : ''}${pattern ? ' pattern-' + pattern : ''}`} 
            style={`background-color: ${color}`} 
            onClick={onClick}
            title = {<Text id={label} />}
        />
    </Localizer>


// WEBPACK FOOTER //
// ./js/components/ColorDot.js